<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar color="primary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text">Dispatch Reports</v-toolbar-title>
                <v-spacer />
            </v-toolbar>
        </v-card>
        <v-card>
            <v-container grid-list-xs fluid class="text-center">
                <h4>Dispatch Report</h4>
                <v-row justify="center">
                    <v-col cols="6">
                        <v-combobox v-model="header" :items="shift_headers" :item-text="'ShiftDate'" :item-value="'ShiftId'"
                            label="Select Shift" auto-select-first hide-details dense></v-combobox>
                    </v-col>
                    <v-col cols="2" margin>
                        <v-combobox v-model="region" :items="regions" :item-text="'PrincipalRegion'"
                            :item-value="'PrincipalRegionID'" label="Select Region" auto-select-first hide-details
                            dense></v-combobox>
                    </v-col>
                    <v-col cols="1">
                        <v-btn @click="getDispatchReport(0)" class="mb-2">
                            <v-icon>mdi-printer </v-icon>
                        </v-btn>
                    </v-col>
                    <!--
                        <v-col cols="1" class="mt-3 mx-3">
                            <v-btn @click="getDispatchReport(true)">
                                <v-icon>mdi-microsoft-excel </v-icon>
                            </v-btn>
                        </v-col>
                        -->
                    <v-col cols="1"> </v-col>
                </v-row>
                <v-divider></v-divider>
                <h4>Report By Date Range</h4>
                <v-row justify="center" class="mt-3">
                    <v-col cols="4">
                        <v-text-field v-model="StartDate" hide-details required label="Start Date" placeholder="YYYY-MM-DD"
                            v-mask="'####-##-##'" dense></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field v-model="EndDate" hide-details required label="Start Date" placeholder="YYYY-MM-DD"
                            v-mask="'####-##-##'" dense></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="2">
                        <v-btn color="primary" class="mr-2" @click="loadTruckDisabled"><v-icon
                                class="mr-1">mdi-truck-alert</v-icon>Disabled Trucks</v-btn>
                    </v-col>
                    <v-col cols="2">
                        <v-btn color="primary" class="mr-r" @click="loadLogsByAdminTracking"><v-icon
                                class="mr-1">mdi-layers-search-outline</v-icon> Audit Admin</v-btn>
                    </v-col>
                    <v-col cols="2">
                        <v-btn color="primary" class="mr-2" @click="loadCommentReport"><v-icon>mdi-comment-text-multiple-outline</v-icon>Shift Comments</v-btn>
                    </v-col>
                    <v-col cols="2">
                        <v-btn color="primary" class="mr-2" @click="PreventiveErrosReport"><v-icon>mdi-alert-circle-outline</v-icon>Preventive Errors</v-btn>
                    </v-col>
                    
                </v-row>
            </v-container>
        </v-card>
        <showLogs v-if="$store.state.audit.show" :data="data" :audit="propst" :report="true"></showLogs>
        <prevErros v-if="$store.state.report.preventive" :data="preventive"></prevErros>
    </v-container>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import { mask } from 'vue-the-mask';
import showLogs from './../Modals/Dispatch/Tracking/showLogs.vue';
import prevErros from './../Modals/Dispatch/Tracking/PreventiveErros.vue';
export default {
    directives: {
        mask
    },
    components: {
        showLogs,
        prevErros
    },
    data: function () {
        return {
            header: [],
            EndDate: null,
            StartDate: null,
            shift_headers: [],
            regions: [],
            region: [],
            data: [],
            propst: [],
        };
    },
    mounted() {
        this.loadShiftHeaders();
        this.loadRegions();
    },
    methods: {
        loadLogsByAdminTracking: function () {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.StartDate,
                EndDate: this.EndDate,
                Year: moment(this.StartDate).year(),
            }
            axios
                .post('audits/admin/gps/tracking', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.data = response.data;
                    await this.data.forEach(data => {
                        if (data.properties != "{\"old\": [], \"attributes\": []}") {
                            data.show = true;
                        } else {
                            data.show = false;
                        }
                    });
                    console.log(this.propst)
                    str.state.isLoading = false;
                    this.$store.state.audit.show = true;
                    console.log(response.data);
                })
                .catch(function (error) {
                    str.state.isLoading = true;
                    console.log(error);
                });
        },
        loadRegions: function () {
            this.$store.state.isLoading = true;
            axios
                .get('regions', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.regions = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadShiftHeaders: function () {
            this.$store.state.isLoading = true;
            axios
                .get('shift-header/dates/15', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.shift_headers = response.data.data;
                    this.chargeShift();
                })
                .catch(function (error) {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        getDispatchReport: function (excel) {
            console.log('Printing...' + this.header['ShiftId']);
            var str = this.$store;

            str.state.isLoading = true;

            if (this.header['ShiftId'] != null) {
                var params = {
                    shift_header: this.header['ShiftId'],
                    region: this.region.PrincipalRegionID,
                    excel: false,
                    no_allocation: 'not-apply'
                }
                console.log(params);
                axios({
                    url:
                        'shift-detail/dispatch-report',
                    method: 'post',
                    data: params,
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                    .then(response => {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;
                        if (excel == true)
                            link.setAttribute(
                                'download',
                                'Dispatch Report.xlsx'
                            );
                        else
                            link.setAttribute(
                                'download',
                                'Dispatch Report.pdf'
                            );

                        document.body.appendChild(link);
                        link.click();
                        str.state.isLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });

                            str.state.isLoading = false;
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });

                            str.state.isLoading = false;
                        }
                    });

            }
        },
        loadTruckDisabled: function () {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.StartDate,
                EndDate: this.EndDate,
                Year: moment(this.StartDate).year(),
            }
            axios({
                url:
                    'truck-idle/report',
                method: 'post',
                data: parms,
                responseType: 'blob',
                headers: {
                    Authorization: 'Bearer ' + this.$store.state.token
                }
            })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        'Disabled Trucks Report.xlsx'
                    );
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });

                        str.state.isLoading = false;
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });

                        str.state.isLoading = false;
                    }
                });

        },
        loadCommentReport: function () {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.StartDate,
                EndDate: this.EndDate,
                Year: moment(this.StartDate).year(),
            }
            axios({
                url:
                    'shift-header/dates/comments/report',
                method: 'post',
                data: parms,
                responseType: 'blob',
                headers: {
                    Authorization: 'Bearer ' + this.$store.state.token
                }
            })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        'Shift Comments Report.pdf'
                    );
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });

                        str.state.isLoading = false;
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });

                        str.state.isLoading = false;
                    }
                });

        },
        PreventiveErrosReport: function () {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.StartDate,
                EndDate: this.EndDate,
            }
            axios
                .post('pre-error-tracking/totals-detail', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(async response => {
                    this.preventive = response.data;
                    this.$store.state.report.preventive = true;
                    str.state.isLoading = false;
                })
                .catch(error => {
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'An error has ocurred, please try again.'
                    });
                    str.state.isLoading = false;
                    console.log(error);
                });

        },


    }
};
</script>
